import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { DatePicker } from "./DateField";

// fields: [{ name, label, type?, options?: [{value,label}], placeholder?, required?, maxLength? }]
export const FormDialog = ({ open, onOpenChange, title, fields, initial, onSubmit, testid }) => {
  const [form, setForm] = useState(initial || {});
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onSubmit(form);
    setBusy(false);
    if (ok) onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-[#1F2A3E] max-w-lg max-h-[90vh] overflow-y-auto" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle className="font-display text-xl">{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4">
          {fields.map((f) => (
            <label key={f.name} className="grid gap-1.5 text-sm">
              <span className="text-slate-400 text-xs font-medium">{f.label}{f.required && " *"}</span>
              {f.options ? (
                <select className="c-input" required={f.required} value={form[f.name] ?? ""} data-testid={`${testid}-${f.name}`}
                  onChange={(e) => set(f.name, e.target.value)}>
                  <option value="">Select…</option>
                  {f.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              ) : f.type === "date" ? (
                <DatePicker value={form[f.name] ?? ""} onChange={(v) => set(f.name, v)} required={f.required} fromYear={f.fromYear || 1940} testid={`${testid}-${f.name}`}
                  defaultMonth={f.name === "dob" ? new Date(1995, 0, 1) : undefined} />
              ) : (
                <input className="c-input" type={f.type || "text"} required={f.required} maxLength={f.maxLength}
                  minLength={f.minLength} placeholder={f.placeholder} value={form[f.name] ?? ""} data-testid={`${testid}-${f.name}`}
                  onChange={(e) => set(f.name, f.type === "number" ? e.target.valueAsNumber : e.target.value)} />
              )}
            </label>
          ))}
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid={`${testid}-submit`}
              className="bg-[#00E599] text-[#0B1017] hover:bg-[#00C482] font-semibold">
              {busy ? "Saving…" : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
